import { DialogTitle } from "components/ui/dialog";
import { DepositConference } from "../../depositConference";
import WaitReturn from "../../waitReturn";
import AccoutingEntries from "../../accountingEntries";

/* eslint-disable @typescript-eslint/no-explicit-any */
export const actions = (
  handleModal: any,
  store_code: string,
  divergenceData: any,
  conciliation_id: string,
  isClosed: boolean
) => {
  return [
    {
      label: "Registro NSU (F10)",
      shortcut: "F10",
      onclick: () => {
        handleModal({
          isOpen: true,
          element: <DepositConference isClosed={isClosed} conciliation_id={conciliation_id} />,
          title: (
            <DialogTitle className="text-[24px] font-medium text-[#2B0C1A] leading-[28px]">
              Conciliação de Caixa - Registro NSU
            </DialogTitle>
          ),
        });
      },
    },
    {
      label: "Lançamento Contábil (F9)",
      shortcut: "F9",
      onclick: () => {
        const accountingEntriesRef = { current: { hasChanges: false } };
        handleModal({
          isOpen: true,
          element: (
            <AccoutingEntries
              store_code={store_code || ""}
              conciliation_date={divergenceData[0]?.conciliation?.date || ""}
              onStateChange={(hasChanges) => {
                accountingEntriesRef.current.hasChanges = hasChanges;
              }}
            />
          ),
          title: (
            <DialogTitle className="text-[24px] font-medium text-[#2B0C1A] leading-[28px]">
              Conciliação de Caixa - Lançamento Contábil
            </DialogTitle>
          ),
        });
      },
    },
    {
      label: "Aguardar Retorno (F8)",
      shortcut: "F8",
      onclick: () => {
        handleModal({
          isOpen: true,
          element: <WaitReturn />,
          title: (
            <DialogTitle className="text-[24px] font-medium text-[#2B0C1A] leading-[28px]">
              Conciliação de Caixa - Aguardar Retorno
            </DialogTitle>
          ),
        });
      },
    },
  ];
};
